import { memo } from 'react';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { UiCard } from 'src/components/UI/Card';

type Props = {
  model: CheckoutConfirmationResponseType['CheckInInstructionsSubsection'];
};

export const CheckoutConfirmationCheckInInstructions = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.checkInInstructions');

  return (
    <>
      <h2 className="section-header">{tHelper('title')}</h2>
      <UiCard>
        {/* eslint-disable-next-line react/no-danger */}
        <div className="fr-view-custom-text" dangerouslySetInnerHTML={{ __html: model.Text }} />
      </UiCard>
    </>
  );
});
